var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescriptionBgIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 561,
    height: 429,
    viewBox: "0 0 561 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 261.53,
    y: 108.272,
    width: 141.453,
    height: 497.84,
    rx: 70.7264,
    transform: "rotate(-49.9455 261.53 108.272)",
    fill: "url(#paint0_linear_1043_89194)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.86264,
    y: 136.684,
    width: 120.164,
    height: 387.217,
    rx: 60.082,
    transform: "rotate(-49.9455 9.86264 136.684)",
    stroke: "url(#paint1_linear_1043_89194)",
    strokeWidth: 14
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_89194",
    x1: 332.257,
    y1: 108.272,
    x2: 332.257,
    y2: 606.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EEAD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_89194",
    x1: 67.082,
    y1: 137.537,
    x2: 67.082,
    y2: 538.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98B6F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionBgIc);
export default __webpack_public_path__ + "static/media/descriptionBg_ic.89b7d553.svg";
export { ForwardRef as ReactComponent };